import { useCallback, useEffect, useRef } from 'react';
const COPY_FEEDBACK_RESET_MS = 1500;
const copyAndDownloadFooter = (copyButtonState)=>({
        layout: 'copyAndDownload',
        copyButtonState: copyButtonState
    });
export const useCopyButtonFeedback = (footer, setFooter)=>{
    const copyFeedbackTimeoutIdRef = useRef(undefined);
    const clearCopyFeedbackTimeout = useCallback(()=>{
        if (copyFeedbackTimeoutIdRef.current == undefined) return;
        clearTimeout(copyFeedbackTimeoutIdRef.current);
        copyFeedbackTimeoutIdRef.current = undefined;
    }, []);
    const resetCopyButtonState = useCallback(()=>{
        if (footer.layout != 'copyAndDownload') return;
        clearCopyFeedbackTimeout();
        setFooter(copyAndDownloadFooter('copy'));
    }, [
        clearCopyFeedbackTimeout,
        footer.layout,
        setFooter
    ]);
    const setCopyResult = useCallback((result)=>{
        if (footer.layout != 'copyAndDownload') return;
        const copyButtonState = result == 'success' ? 'copied' : 'cantCopy';
        setFooter(copyAndDownloadFooter(copyButtonState));
        clearCopyFeedbackTimeout();
        if (result == 'success') {
            copyFeedbackTimeoutIdRef.current = setTimeout(()=>{
                setFooter(copyAndDownloadFooter('copy'));
            }, COPY_FEEDBACK_RESET_MS);
        }
    }, [
        clearCopyFeedbackTimeout,
        footer.layout,
        setFooter
    ]);
    useEffect(()=>()=>clearCopyFeedbackTimeout(), [
        clearCopyFeedbackTimeout
    ]);
    return {
        resetCopyButtonState: resetCopyButtonState,
        setCopyResult: setCopyResult
    };
};
